import { Box } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

const PreBillingCustomerAdjustmentAccepted = ({ event }: { event: any }) => {
  const acceptedEmail = event.data?.acceptingEmail;
  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        <EventBy event={event} /> Pre-Billing Discounted Quote Accepted by {acceptedEmail}
      </Box>
    </Box>
  );
};

export default PreBillingCustomerAdjustmentAccepted;
